import { Button, Grid, Switch } from "@material-ui/core";
import AddIcon from '@material-ui/icons/Add';
import Authorize from "components/Authorize";
import { permissionProfiles } from "components/Authorize/permissionProfiles";
import LoadingSpinner from "components/LoadingSpinner";
import { useGetAllCarriersQuery } from "features/carriers/carrierSlice";
import { selectIsClient } from "features/user/userSlice";
import { IconAccessCode } from "icons";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import DataListHeader from "../../components/DataListHeader";
import PageComponent from "../../components/Page/PageComponent";
import FilterService, { fieldTypes } from "../../services/filterService";
import { useGetLotsQuery } from "../lots/lotSlice";
import { AccessGroupTypes, AccessGroupTypesList } from "./accessConsts";
import AccessDialog from "./AccessDialog";
import AccessGroupList from "./AccessGroupList";
import { useGetAccessesByGroupTypeQuery } from "./accessSlice";
import { setFilters, setSearchVal } from "./accessStateSlice";
import GenerateOneTimeAccess from "./GenerateOneTimeAccess/GenerateOneTimeAccess";
import OpenGate from "./OpenGate/OpenGate";
import { AccessStyle } from "./Style";

const AccessPage = () => {
    const classes = AccessStyle();

    let { id } = useParams();

    const { searchVal, filters } = useSelector(state => state.accessState);
    const dispatch = useDispatch();
    const isClient = useSelector(selectIsClient);

    const [selectedGroupType, setSelectedGroupType] = useState(AccessGroupTypes.CLIENT);
    const [showExpiringSoon, setShowExpiringSoon] = useState(false);

    let { data: lots, error: lotError, isLoading: isLoadingLots } = useGetLotsQuery();
    let { data: carriers, error: carriersError, isLoading: isLoadingCarriers } = useGetAllCarriersQuery();
    let { data: accessData, error: accessError, isFetching: isLoadingAccess } = useGetAccessesByGroupTypeQuery(selectedGroupType);

    lots = lots || [];
    carriers = carriers || [];
    accessData = accessData || [];

    const isLoading = isLoadingLots || isLoadingCarriers || isLoadingAccess;

    accessData = accessData.map(a => ({
        ...a,
        lots: lots?.filter(l => a?.lotIds?.includes(l?.id)),
    }));

    useEffect(() => {
        if (id > 0) {
            dispatch(setSearchVal(id));
        }
    }, [id]);

    if (showExpiringSoon) {
        accessData = accessData.filter(a => a.hasAnExpiringCode === true);
    }

    const [openModal, setOpenModal] = useState(false);

    const handleClose = () => {
        setOpenModal(false)
    }

    let filterConfig = [
        { type: 'text', size: 3, title: 'Access Group Type', key: 'groupType', showEmpty: false, values: AccessGroupTypesList?.filter(a => !isClient || (isClient && a.showForClient)) },
        { type: fieldTypes.LOT, size: 2, title: 'Lot', key: 'lotId', values: lots, specialBehaviorHandler: () => true, ownedByTenant: true },
    ];

    if (selectedGroupType == AccessGroupTypes.CARRIER) {
        filterConfig.push({ type: 'text', size: 2, title: 'Carrier', key: 'carrierId', values: carriers })
    }

    const onSearch = value => {
        dispatch(setSearchVal(value.trim()));
    };

    const onDropFilter = (filterValue, prop) => {
        if (prop == "groupType") {
            setSelectedGroupType(filterValue)
            dispatch(setFilters({ ...filters, [prop]: { value: filterValue }, ["carrierId"]: { value: null } }));
        } else {
            dispatch(setFilters({ ...filters, [prop]: { value: filterValue } }));
        }
    };

    let filteredData = FilterService.filter(filters, searchVal, accessData, filterConfig);
    filteredData = filteredData?.filter(d => !filters?.lotId?.value || d?.lotIds?.includes(+filters?.lotId?.value));

    return (
        <PageComponent
            header={<DataListHeader
                title={(
                    <Grid container alignItems="center">
                        <IconAccessCode style={{ marginRight: '0.5em' }} />
                        {'Authorized Access'}
                    </Grid>
                )}
                data={accessData}
                dropDownsConfig={filterConfig}
                filters={filters}
                onDropFilter={onDropFilter}
                onSearch={onSearch}
                searchVal={searchVal}
                actionButtons={(
                    <Grid container spacing={1}>
                        <Grid item>
                            <div className={classes.expiringSoonWrapper}>
                                <Switch
                                    checked={showExpiringSoon}
                                    onChange={() => setShowExpiringSoon(!showExpiringSoon)}
                                    color="primary"
                                    size="small"
                                />
                                <span className={classes.expiringSoonLabel}>
                                    Show Expiring Soon
                                </span>
                            </div>
                        </Grid>
                        <Authorize profile={permissionProfiles.ACCESS.MANAGE_ACCESS}>
                            <Grid item>
                                <Button variant="outlined" //color="primary" 
                                    startIcon={<AddIcon className={classes.icon} />}
                                    onClick={() => setOpenModal(true)}>
                                    Create Access
                                </Button>
                            </Grid>
                        </Authorize>
                        <Grid item>
                            <OpenGate />
                        </Grid>
                        <Grid item>
                            <GenerateOneTimeAccess />
                        </Grid>
                    </Grid>
                )}
            />}
        >
            <>
                <AccessDialog open={openModal} handleClose={handleClose} />

                <LoadingSpinner loading={isLoading} />
                <AccessGroupList accessGroups={filteredData} groupType={selectedGroupType} isLoading={isLoading}/>
            </>
        </PageComponent>

    );
}

export default AccessPage;
